import { useTranslation } from "react-i18next";

import { IconTool02 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";
import { ROUTES } from "@constants/routes";
import { useMaintenanceById } from "@hooks/inventory/maintenance/useMaintenanceById";
import { MaintenanceType } from "@type/inventory/maintenance";

const { INVENTORY } = ROUTES;

const { MAINTENANCE } = INVENTORY;

export default function MaintenanceDetailsHeader() {
  const { t } = useTranslation();

  const { updateMaintenanceHandler, maintenanceState } = useMaintenanceById();

  const singleMaintenance = maintenanceState.getSingleData
    ?.data as MaintenanceType;

  const { product } = singleMaintenance || {};

  const breadcrumbs = [
    {
      icon: <IconTool02 fill="dark" size="20" />,
    },
    {
      label: t("INVENTORY_MAINTENANCE.HEADING"),
      link: MAINTENANCE,
    },
    {
      label: product,
    },
  ];

  const headerText = {
    header: product,
  };

  return <Header headerText={headerText} breadcrumbs={breadcrumbs} />;
}
